export default {
    agreement_categories: "Макулдуктун категориялары",
    app_code: "Демилгечи тиркеме коду",
    authentication_login: "Аутентификация логини",
    authentication_password: "Аутентификация жашырынсөзү",
    cod_no: "Код НО",
    credentials_of_authorized_person: "Ыйгарым укуктуу адамды авторизациялоо",
    director: "Директор",
    do_you_confirm_sending_feedback_url_to_patient_messenger: "Мессенджерде пациентке сын-пикир жазуу үчүн шилтемени жөнөтүүнү ырастайсызбы?",
    do_you_confirm_sending_receipt_to_patient_messenger: "Сиз мессенжер аркылуу бейтапка квитанцияны жөнөтүүнү ырастайсызбы?",
    employee_login: "Кызматкердин логини",
    employee_password: "Кызматкердин жашырынсөзү",
    fdoc_instruction: "Кызмат туура иштеши үчүн, FDoc менеджерине хуктарды/сурамдарды кабыл ала турган IP дарегин бериңиз: <code>{ipaddress}</code>. Ошондой эле сиз алууну каалаган окуяларды атаңыз: <code>SetStatus, SetStatusMessage, SetStatusPackageByClient</code>",
    fdoc_multiple_signers_instruction: "Персонал бөлүмүндө, кызматкерди түзөтүүдө, FDoc өтмөгүндө FDoc тутумунун кызматкердин логини жана жашырынсөзү болушу керек.",
    files: "Файлдары",
    files_being_uploaded: "Файлдар жүктөлүүдө. Жүктөө аяктаганга чейин баракты жаппаңыз.",
    fill_questionary: "Анкетаны толтуруңуз",
    first_new: "Жаңылары биринчи",
    first_old: "Биринчиден, эскилери",
    gallery: "Галерея",
    header_in_akt: "Көрсөтүлгөн кызматтардын актысында кап",
    multiple_signers_support: "Бир нече кол коюучуларды колдоо",
    options: "Опциялар",
    or_folder_with_dcm_files: "же DCM-файлдар менен папка",
    select_folder: "Папканы тандаңыз",
    send_receipt_to_messenger: "Бейтаптын мессенджерине квитанция жөнөтүңүз",
    sign_selected_via_vendor: "{vendor} аркылуу тандалганга кол коюу",
    table: "Таблица"
}
